import React, { useRef, useState, useEffect } from 'react';
import { Tooltip } from 'antd';

const SmartTruncateText = ({
  text,
  lineClamp = 1,  // 默认单行，设置为数字可切换多行
  width = '100%',
  style = {},
  placement
}) => {
  const containerRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);

  // 通用溢出检测逻辑
  const checkOverflow = (element) => {
    if (lineClamp === 1) {
      // 单行检测逻辑
      return element.scrollWidth > element.clientWidth;
    } else {
      // 多行检测逻辑
      return element.scrollHeight > element.clientHeight;
    }
  };

  useEffect(() => {
    const element = containerRef.current;
    if (!element) return;

    const handleResize = () => {
      setShowTooltip(checkOverflow(element));
    };

    // 初始检测
    handleResize();
    
    // 监听变化
    const observer = new ResizeObserver(handleResize);
    observer.observe(element);
    
    return () => observer.disconnect();
  }, [text, lineClamp]);

  // 动态样式生成
  const textStyle = {
    width,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: 1.3, // 必须设置
    ...(lineClamp === 1 
      ? { 
          whiteSpace: 'nowrap', // 单行样式
          display: 'inline-block' 
        }
      : { 
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: lineClamp // 多行样式
        }),
    ...style // 允许自定义样式覆盖
  };

  const tooltipStyle = {
    width,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: 1.3, // 必须设置
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 20 // 多行样式
  }

  return (
    <Tooltip placement={placement} title={showTooltip ? <p style={tooltipStyle}>{text}</p> : null}>
      <div ref={containerRef} style={textStyle}>
        {text}
      </div>
    </Tooltip>
  );
};

export default SmartTruncateText